import {FC} from "react";
import {
    IDriveThruCarEvent,
    IDriveThruTransaction
} from "../api/driveThruReplayModels";
import {CascadeInfo, CascadeCategory} from "../api/driveThruReplayModels";
import {getOrderPreview, getPaymentDescription} from "../driveThruReplayUtils";
import {formatDuration} from "@/features/coachInsights/api/coachInsightsUtils";

interface ICascadeSibling {
    event: IDriveThruCarEvent;
    transaction: IDriveThruTransaction | null;
    cascadeInfo: CascadeInfo;
}

interface IProps {
    siblings: ICascadeSibling[];
    onSelectEvent: (eventId: string) => void;
}

const DriveThruCascadeContext: FC<IProps> = ({siblings, onSelectEvent}) => {
    if (siblings.length === 0) return null;

    return (
        <div className="drive-thru-replay-cascade-context">
            <div className="drive-thru-replay-cascade-context-header">
                Other Cars in This Cascade
            </div>
            <div className="drive-thru-replay-cascade-context-list">
                {siblings.map(({event, transaction, cascadeInfo}) => {
                    const preview = getOrderPreview(transaction);
                    const paymentDescription = getPaymentDescription(transaction);
                    return (
                        <button
                            key={event.id}
                            className="drive-thru-replay-cascade-sibling-card"
                            onClick={() => onSelectEvent(event.id)}
                        >
                            <div className="drive-thru-replay-sibling-top">
                                <span className="drive-thru-replay-sibling-label">
                                    Car #{event.vehicleNumber}
                                </span>
                                <span
                                    className="drive-thru-replay-sibling-role"
                                    data-cascade-role={cascadeInfo.category}
                                >
                                    {cascadeInfo.category === CascadeCategory.Cascade
                                        ? "Trigger"
                                        : "Affected"}
                                </span>
                                <span
                                    className={`drive-thru-replay-sibling-duration${
                                        event.isOverThreshold ? " over" : ""
                                    }`}
                                >
                                    {formatDuration(event.totalServiceSeconds)}
                                </span>
                            </div>
                            {preview && (
                                <div className="drive-thru-replay-sibling-preview">
                                    {preview}
                                </div>
                            )}
                            {transaction && (
                                <div className="drive-thru-replay-sibling-cashier">
                                    {event.cashierName}
                                    {paymentDescription
                                        ? ` · ${paymentDescription}`
                                        : ""}
                                </div>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DriveThruCascadeContext;
